export const SHIPPING = [
  {
    label: "IPC",
    id: 1,
  },
  {
    label: "IPC Keep",
    id: 2,
  },
  {
    label: "Best Way",
    id: 3,
  },
  {
    label: "CH Robinson - Domest",
    id: 4,
  },
  {
    label: "eShip",
    id: 5,
  },
  {
    label: "eshipping.biz",
    id: 6,
  },
  {
    label: "eshipping.biz",
    id: 7,
  },
  {
    label: "FedEx",
    id: 8,
  },
  {
    label: "FedEx Freight",
    id: 9,
  },
  {
    label: "FedEx Overnight",
    id: 10,
  },
  {
    label: "Freight",
    id: 11,
  },
  {
    label: "LFS",
    id: 12,
  },
  {
    label: "LTL",
    id: 13,
  },
  {
    label: "Motor Freight",
    id: 14,
  },
  {
    label: "Routing Guide",
    id: 15,
  },
  {
    label: "SAIA LTL Freight",
    id: 16,
  },
  {
    label: "Truck",
    id: 17,
  },
  {
    label: "Trucking",
    id: 18,
  },
  {
    label: "UPS",
    id: 19,
  },
  {
    label: "UPS 770156",
    id: 20,
  },
  {
    label: "Victaulic",
    id: 21,
  },
  {
    label: "Will Call",
    id: 22,
  },
  {
    label: "XPO",
    id: 23,
  },
  {
    label: "XPO-Clt",
    id: 24,
  },
  {
    label: "XPO-Collect",
    id: 25,
  },
  {
    label: "Modern Heat Treat",
    id: 26,
  },
  {
    label: "Other",
    id: 26,
  },
];

export const TERMS = [
  { id: 1, label: "Due on Receipt" },
  { id: 2, label: "Net 7" },
  { id: 3, label: "Net 10" },
  { id: 4, label: "Net 15" },
  { id: 5, label: "Net 20" },
  { id: 6, label: "Net 30" },
  { id: 7, label: "Net 45" },
  { id: 8, label: "Net 60" },
  { id: 9, label: "Net 90" },
  { id: 10, label: "EOM (End of Month)" },
  { id: 11, label: "2/10 Net 30 (2% discount if paid within 10 days)" },
  { id: 12, label: "COD (Cash on Delivery)" },
  { id: 13, label: "CIA (Cash in Advance)" },
  { id: 14, label: "PIA (Payment in Advance)" },
  { id: 15, label: "CBD (Cash Before Delivery)" },
  { id: 16, label: "EOM + 30" },
  { id: 17, label: "15th of the Month Following" },
  { id: 18, label: "2/15 Net 45 (2% discount if paid within 15 days)" },
  { id: 19, label: "Contra Payment (Offset with Receivables)" },
  { id: 20, label: "Custom Terms" },
];

export const UNITS = [
  { id: 1, label: "EA" },
  { id: 2, label: "LB" },
  { id: 3, label: "GAL" },
  { id: 4, label: "HR" },
  { id: 5, label: "PR" },
];
